import type { SaveCommentaryTemplateDto } from "@eu.mdotm.api/sphere";
import { useTypedNavigation } from "$root/components/PlatformRouter/RoutesDef";
import { spawnCreateDialog } from "$root/components/spawnable/entity-management/create-dialog";
import StoryfolioInner from "$root/functional-areas/storyfolio";
import { stableDefaultConfiguration, stableEmptyCommentaryTemplate } from "$root/functional-areas/storyfolio/common";
import { storyfolioRepository } from "$root/functional-areas/storyfolio/repository";
import { platformToast } from "$root/notification-system/toast";
import { noop } from "@mdotm/shadcn/legacy/utils";

function StoryfolioCreation(): React.JSX.Element {
	const { push } = useTypedNavigation();

	async function createStoryfolioTemplate(template: SaveCommentaryTemplateDto) {
		try {
			await storyfolioRepository.create(template);

			platformToast({
				children: "Commentary template created successfully",
				icon: "Ask-ai",
				severity: "success",
			});
			push("Storyfolio/Studio", {});
		} catch (error) {
			platformToast({
				children: "Something went wrong please, try later",
				icon: "Ask-ai",
				severity: "error",
			});
			throw error;
		}
	}

	const template = stableEmptyCommentaryTemplate;

	return (
		<StoryfolioInner
			template={{
				...template,
				dynamicsBlock: { ...template.dynamicsBlock, tagUUID: template.dynamicsBlock.tagUUID ?? undefined },
				metricsBlock: { ...template.metricsBlock, tagUUID: template.metricsBlock.tagUUID ?? undefined },
				portfolioCompositionBlock: {
					...template.portfolioCompositionBlock,
					tagUUID: template.portfolioCompositionBlock.tagUUID ?? undefined,
				},
				instrumentInsightsBlock: stableDefaultConfiguration.instrumentInsightsBlock(template.instrumentInsightsBlock),
			}}
			onSubmit={async (editedTemplate) => {
				await spawnCreateDialog({
					entityType: "template",
					onSubmitAsync: (name) => createStoryfolioTemplate({ ...editedTemplate, name }),
					checkIfNameIsAvailable: storyfolioRepository.isCommentaryNameIsAvailable,
					placeholder: editedTemplate.name ?? "Untitled template",
					header: "Rename Template",
				}).catch(noop);
			}}
		/>
	);
}

export default StoryfolioCreation;
